var map = {
	"./add-attachment-to-mail.js": "4Uzs",
	"./ai2.js": "2fLw",
	"./all-atachments-upload.js": "+7TK",
	"./assets.js": "rW0x",
	"./client.js": "bitn",
	"./data-protection.js": "zv0b",
	"./dm-explorer.js": "pNEj",
	"./document-excel.js": "Ce+I",
	"./document-image.js": "ASLE",
	"./document-pdf2.js": "nUeh",
	"./document-powerpoint.js": "SmiS",
	"./document-text.js": "KfbB",
	"./document-word.js": "yXoB",
	"./empty-icon.js": "QPbm",
	"./event-cancel.js": "AqnU",
	"./event-send.js": "CkYk",
	"./file-cs.js": "NGTm",
	"./file-css.js": "bBRz",
	"./file-eaf.js": "WLlN",
	"./file-js.js": "YOc6",
	"./file-json.js": "Vk9p",
	"./file-mp4.js": "nFK/",
	"./file-ts.js": "bhet",
	"./file-webp.js": "KNbQ",
	"./folder2-compressed.js": "/okQ",
	"./folder2.js": "L/q+",
	"./form-project.js": "uVPe",
	"./help-desk.js": "zQYV",
	"./home.js": "fxe5",
	"./human-resources.js": "ou5G",
	"./indicators.js": "he5U",
	"./login.js": "vD2e",
	"./logout.js": "lcAc",
	"./new-proj-file.js": "/miE",
	"./other-app.js": "j8sW",
	"./recent-items.js": "Meqa",
	"./references.js": "F01m",
	"./reporsitories2.js": "gGXy",
	"./reports.js": "uI1w",
	"./save-current-mail.js": "OM6A",
	"./server.js": "Rvj0",
	"./settings.js": "Pydz",
	"./shortcut.js": "XHhm",
	"./synergy.js": "EPqU",
	"./upload-selected.js": "t0+o",
	"./workflow-management.js": "v19z"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6Jgo";